import { RouterOutput } from '../trpc/router';

export function resolveName(dbUser: RouterOutput['users']['byId']['data'], username?: string) {
  if (!dbUser.firstName && !dbUser.lastName && !username) return '';
  if (!dbUser.firstName && !dbUser.lastName && username) return username;
  if (dbUser.firstName && !dbUser.lastName) return dbUser.firstName;
  return `${dbUser.firstName} ${dbUser.lastName}`;
}
